import { BraidPortal } from 'braid-design-system';
import { atoms } from 'braid-design-system/css';
import { FormProvider, useForm } from 'react-hook-form';

interface Props {
  debug?: boolean;
  defaultValues: Record<string, any>;
  children: React.ReactNode;
}

export function RootFormProvider({
  debug = false,
  defaultValues,
  children,
}: Props) {
  const rootForm = useForm({ defaultValues, delayError: 500 });

  const elements = <FormProvider {...rootForm}>{children}</FormProvider>;
  if (debug) {
    const className = atoms({ padding: 'gutter', margin: 'none' });

    return (
      <>
        {elements}
        <BraidPortal>
          <pre
            id="root-form-debug"
            className={className}
            style={{ backgroundColor: 'black', color: 'white' }}
          >
            <code>{JSON.stringify(rootForm.watch(), null, 2)}</code>
            <br />
            <code>{JSON.stringify(rootForm.formState.isValid, null, 2)}</code>
            <br />
            <code>{JSON.stringify(rootForm.formState.errors, null, 2)}</code>
          </pre>
        </BraidPortal>
      </>
    );
  }
  return elements;
}
